import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import HelpCenterSettingsEmbeddedWidgetsAppQuery from './src/ui/__generated__/HelpCenterSettingsEmbeddedWidgetsAppQuery.graphql';

export const embeddedEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() =>
			import(
				/* webpackChunkName: "async-help-center-setting-embedded-widgets-app" */ './src/ui/HelpCenterSettingsEmbeddedWidgetsApp.tsx'
			),
	),
	getPreloadProps: ({
		context: {
			match: {
				params: { helpCenterId, widgetId },
			},
		},
		tenantContext: { cloudId, activationId },
	}: EntryPointRouteParams) => {
		return {
			queries: {
				embeddedWidgetsQuery: {
					parameters: HelpCenterSettingsEmbeddedWidgetsAppQuery,
					variables: {
						cloudId,
						helpCenterAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`,
						widgetId: widgetId ?? '',
					},
					options: {
						fetchPolicy: 'store-or-network' as const,
					},
				},
			},
		};
	},
});
